import React from 'react';
import styled from 'styled-components/macro';
import { App } from '../../../app';
import { forMinWidth } from '../../../theme/breakpoints';
import { HistoryItem, RootPost, StateTag } from '../../../RootPost';

export interface StateChangeProps {
    stateChangeEntry: HistoryItem;
    ticket: RootPost;
    className?: string;
}

export default function StateChange(props: StateChangeProps): JSX.Element {
    const { stateChangeEntry, ticket, className } = props;

    return <Wrapper className={`timeline-item ${className ?? ''}`}>
        <span>
            <span>
                {stateChangeEntry.tagId === StateTag.new && <a href={ticket.createdByUrl} target="_blank" rel="noopener noreferrer">{ticket.author.name}</a>}
                {stateChangeEntry.tagId !== StateTag.new && <a href={App.GetUserProfileLink("siteadmin")} target="_blank" rel="noopener noreferrer">Feedback Bot</a>}
                &nbsp;&nbsp;&nbsp;&nbsp;</span>
            
            <span className={`pill post-state ${stateChangeEntry.status}`}>
                {App.LocalizeStateName(stateChangeEntry.status, ticket?.type)}
            </span>
        </span>
        <span className="light-text">{App.ParseDateTimeToLocal(stateChangeEntry.date)}</span>
    </Wrapper >
}

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0 1rem 0 1.5rem;

    background-color: var(--color-background);

    min-height: var(--timeline-header-min-height);

    >* + * {
        margin-top: .5rem;
        margin-left: 0;
    }

    .light-text {
        color: var(--color-on-background-lighter);
        font-size: 1.6rem;
    }

    ${forMinWidth.md`
        flex-direction: row;
        align-items: center;

        >* + * {
            margin-top: 0;
            margin-left: .5rem;
        }
    `}

    .pill.pill {
        display: inline-block;
        font-size: 1.2rem;
        padding: .4rem .8rem;
        border-radius: .3rem;
        line-height: 100%;
    }
`;
